/* eslint-disable no-useless-constructor */
/* eslint-disable no-empty-function */
import { logger as defaultLogger } from './logger';

type Logger = typeof defaultLogger;

export class Loggable {
  constructor(
    private readonly namespace: string,
    private readonly loggerImpl: Partial<Logger> = defaultLogger,
  ) {}

  private doLog(level: keyof Logger, ...args: any[]): void {
    if (this.loggerImpl[level]) {
      this.loggerImpl[level]?.(`[${this.namespace}]`, ...args);
    }
  }

  public get logger(): Logger {
    return {
      log: (...msgs: any[]) => this.doLog('log', ...msgs),
      debug: (...msgs: any[]) => this.doLog('debug', ...msgs),
      info: (...msgs: any[]) => this.doLog('info', ...msgs),
      trace: (...msgs: any[]) => this.doLog('trace', ...msgs),
      warn: (...msgs: any[]) => this.doLog('warn', ...msgs),
      error: (...msgs: any[]) => this.doLog('error', ...msgs),
    };
  }
}
